import React from "react";
import { InputRangeRow } from "./index";
// Used by Hacoba NSA-HS machine

export default function UnderWindSRow() {
   return (
      <InputRangeRow
         titleProp={"Underwind S"}
         descriptionProp={""}
         sizeProp={4}
         typeProp={"text"}
         minProp={0}
         maxProp={99999}
         propertyNameProp={"underwindS"}
         errorDialogueProp={"0-99,999 only"}
         floatProp={false}
      />
   );
}
